import React from "react";
import "./brand.css";

function Brand() {
  return (
    <div className="web3wise__brand section__padding">
      <button class="ui-btn">
        <span>Blockchain</span>
      </button>
      <button class="ui-btn">
        <span>Décentralisation</span>
      </button>
      <button class="ui-btn">
        <span>Cryptomonnaie </span>
      </button>
      <button class="ui-btn">
        <span>Contrats intelligents</span>
      </button>
      <button class="ui-btn">
        <span>DAO</span>
      </button>
    </div>
  );
}

export default Brand;
